export default {
  meta: {
    title: '开发部踩点统计报表（一鸣）'
  }
};
